import { render, staticRenderFns } from "./panel_item.vue?vue&type=template&id=1bb904be&scoped=true&"
import script from "./panel_item.vue?vue&type=script&lang=js&"
export * from "./panel_item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bb904be",
  null
  
)

export default component.exports